import { type TFunction } from "i18next";

/**
 * The display label of a record another row links to — a task's linked
 * record, a document's anchor. The server resolves each kind's own name, but a
 * case has no title, so a linked case's label arrives as its raw condition
 * type; it reads here through `violations:type.*` (a value the bundle does not
 * carry renders as sent). Every other kind's label passes through untouched.
 * The caller's `t` must reach the `violations` namespace.
 */
export function linkedRecordLabel(
  t: TFunction,
  kind: string | null | undefined,
  label: string,
): string {
  if (kind !== "violation" || label === "") return label;
  return t(`type.${label}`, { ns: "violations", defaultValue: label });
}
